<template>
  <ValidationProvider
    v-slot="{ errors, flags }"
    :name="$t('forms.labels.phoneNumber')"
    :rules="{required: required}"
  >
    <vue-tel-input
      v-model="mutableValue"
      class="blocPhone"
      :disabled="disabled"
      :autoDefaultCountry="false"
      :defaultCountry="team.country"
      :class="{'phone-error-msg' : refObserver && refObserver.ctx.validated}"
      :inputOptions="{
        placeholder: required ? $t('forms.labels.phoneNumberRequired') : $t(phonePlaceholder),
      }"
      :dropdownOptions="{showFlags:true,showDialCodeInSelection:true}"
      :data-cy="cyData"
      :onlyCountries="countries"
      :preferredCountries="[]"
      @input="inputChange"
      @country-change="countryChanged"
    >
      <template v-slot:arrow-icon>
        <span>▼</span>
      </template>
    </vue-tel-input>
    <span
      v-if="!mutableValue"
      class="v-messages theme--light error--text"
    >{{ errors[0] }} <br></span>
    <span
      v-if="flags.touched && !isPhoneNumberValid"
      class="v-messages theme--light error--text"
    >
      {{ $t('forms.labels.phoneError') }}
    </span>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import { VueTelInput } from 'vue-tel-input';
import countryList from '@/constants/acceptedCountries';
import { mapGetters } from 'vuex';

export default {
    components: {
        ValidationProvider,
        VueTelInput,
    },

    props: {
        isPhoneNumberValid: {
            type: Boolean,
            default: true,
        },
        required: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        value: {
            type: String,
            default: '',
        },
        refObserver: {
            type: Object,
            default: null,
        },
        cyData: {
            type: String,
            default: 'phoneNumber',
        },
        phonePlaceholder: {
            type: String,
            default: 'forms.labels.phoneNumber',
        },
    },
    data() {
        return {
            mutableValue: null,
            countryCode: '',
        };
    },
    computed: {
        ...mapGetters([
            'team',
        ]),
        countries() {
            return countryList;
        },
    },
    watch: {
        value: {
            handler(newValue) {
                this.mutableValue = newValue;
            },
            immediate: true,
        },
    },
    methods: {
        isError(errors) {
            return this.refObserver && this.refObserver.ctx.validated && errors.length;
        },
        inputChange(number, payload) {
            this.$emit('inputChanged', number, payload);
        },
        countryChanged(number, payload) {
            this.mutableValue = null;
            this.$emit('inputChanged', number, payload);
        },
    },
};
</script>
<style lang="scss" scoped>
    .phone-error-msg {
        height: 54px;
    }
    .blocPhone {
        white-space:nowrap;
    }
</style>
